import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './DetalleEventoSponsorPage.css';

function DetalleEventoSponsorPage() {
  const { eventId } = useParams();
  const [evento, setEvento] = useState(null);
  const [comprobanteModalUrl, setComprobanteModalUrl] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/sponsor/events/${eventId}/detalle`)
      .then(res => res.json())
      .then(setEvento)
      .catch(err => console.error("Error al cargar detalle del evento:", err));
  }, [eventId]);

  if (!evento) return <p>Cargando evento...</p>;

  const {
    eventDTO,
    totalVisitas,
    totalBoletosVendidos,
    totalRecaudado,
    totalPagado,
    totalPendiente,
    pagosDto
  } = evento;

  return (
    <div className="detalle-evento-container">
      <h2 className="detalle-titulo">{eventDTO.title}</h2>

      {eventDTO.imageUrl && (
        <img
          src={eventDTO.imageUrl}
          alt={`Imagen de ${eventDTO.title}`}
          className="detalle-imagen-pequena"
        />
      )}

      <div className="tabla-info-evento">
        <h3>Información del Evento</h3>
        <table>
          <tbody>
            <tr><td><strong>Título:</strong></td><td>{eventDTO.title}</td></tr>
            <tr>
              <td><strong>Descripción:</strong></td>
              <td>
                <div dangerouslySetInnerHTML={{ __html: eventDTO.description }} />
              </td>
            </tr>
            <tr><td><strong>Fecha:</strong></td><td>{new Date(eventDTO.date).toLocaleString('es-DO')}</td></tr>
            <tr><td><strong>Lugar:</strong></td><td>{eventDTO.placeName}</td></tr>
            <tr><td><strong>Dirección:</strong></td><td>{eventDTO.placeAddress}</td></tr>
            <tr><td><strong>Ciudad:</strong></td><td>{eventDTO.placeCity}</td></tr>
          </tbody>
        </table>
      </div>

      <div className="tabla-metricas">
        <h3>Resumen Financiero</h3>
        <table>
          <tbody>
            <tr><td><strong>Visitas:</strong></td><td>{totalVisitas}</td></tr>
            <tr><td><strong>Boletos vendidos:</strong></td><td>{totalBoletosVendidos}</td></tr>
            <tr><td><strong>Total recaudado:</strong></td><td>${totalRecaudado.toFixed(2)}</td></tr>
            <tr><td><strong>Monto ya pagado:</strong></td><td>${totalPagado.toFixed(2)}</td></tr>
            <tr><td><strong>Pendiente por pagar:</strong></td><td>${totalPendiente.toFixed(2)}</td></tr>
          </tbody>
        </table>
      </div>

      {eventDTO.eventAreas?.length > 0 && (
        <div className="tabla-areas">
          <h3>Áreas del Evento</h3>
          <table>
            <thead>
              <tr>
                <th>Área</th>
                <th>Precio</th>
                <th>Asientos disponibles</th>
              </tr>
            </thead>
            <tbody>
              {eventDTO.eventAreas.map(area => (
                <tr key={area.id}>
                  <td>{area.name}</td>
                  <td>${area.price.toFixed(2)}</td>
                  <td>{area.availableSeats}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {eventDTO.imageMapUrl && (
        <div className="mapa-estatico-container">
          <h3>Mapa del Evento</h3>
          <img
            src={eventDTO.imageMapUrl}
            alt="Mapa del evento"
            className="mapa-estatico"
          />
        </div>
      )}

      {pagosDto?.length > 0 && (
        <div className="tabla-pagos">
          <h3>Pagos Realizados al Organizador</h3>
          <table>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Monto</th>
                <th>Banco</th>
                <th>No. Cuenta</th>
                <th>Tipo</th>
                <th>Moneda</th>
                <th>Método</th>
                <th>Nota</th>
                <th>Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {pagosDto.map(pago => (
                <tr key={pago.id}>
                 <td data-label="Fecha">{new Date(pago.paymentDate).toLocaleDateString()}</td>
                    <td data-label="Monto">${pago.amount.toFixed(2)}</td>
                    <td data-label="Banco">{pago.bankName}</td>
                    <td data-label="No. Cuenta">{pago.accountNumber}</td>
                    <td data-label="Tipo">{pago.accountType}</td>
                    <td data-label="Moneda">{pago.currency}</td>
                    <td data-label="Método">{pago.paymentMethod}</td>
                    <td data-label="Nota">{pago.note}</td>
                    <td data-label="Comprobante">
                    <button onClick={() => setComprobanteModalUrl(pago.proofUrl)}>Ver</button>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {comprobanteModalUrl && (
        <div className="modal-overlay" onClick={() => setComprobanteModalUrl(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="cerrar-modal" onClick={() => setComprobanteModalUrl(null)}>✖</button>
            <img src={comprobanteModalUrl} alt="Comprobante de pago" />
          </div>
        </div>
      )}
    </div>
  );
}

export default DetalleEventoSponsorPage;
